import styled from '@emotion/styled';
import { WHITE, oshical_green, BLACK,LIGHT_BLUE } from '../../styles/color';

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0 100px; /* 上部と下部にマージンを追加 */
  table-layout: fixed;
`;

export const TableSum = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0 10px; /* 上部と下部にマージンを追加 */
  table-layout: fixed;
`;

export const TableHeader = styled.th`
  background-color: ${LIGHT_BLUE};
  color: ${WHITE};
  padding: 10px;
  text-align: left;
  border: 1px solid ${BLACK};
  font-size: 12px;
  text-align: center;
`;

export const TableHeaderSum = styled.th`
  background-color: ${oshical_green};
  color: ${WHITE};
  padding: 10px;
  text-align: left;
  border: 1px solid ${BLACK};
  font-size: 12px;
  text-align: center;
`;
export const TableHeaderSumForJM = styled.th`
  background-color: ${LIGHT_BLUE};
  color: ${WHITE};
  padding: 10px;
  text-align: left;
  border: 1px solid ${BLACK};
  font-size: 12px;
  text-align: center;
`;

export const TableCell = styled.td`
  padding: 10px;
  border: 1px solid ${BLACK};
`;

export const TableRow = styled.tr`
  // &:nth-of-type(even) {
  //   background-color: ${BLACK}10; // 10% opacity
  // }
`;

export const TitleCell = styled(TableCell)`
  word-break: break-all; 
  word-wrap: break-word;
`;